module.exports = __webpack_public_path__ + "static/media/6-3.b654d87f.mp3";